import React from 'react';

import BaseCell from '../BaseCell';
import ToggleControl from '../../../controls/ToggleControl';

export interface ToggleCellProps {
  checked: boolean;
  onChange: (checked: boolean, e: React.MouseEvent) => void;
  disabled?: boolean;
  showSpinner?: boolean;
}

const ToggleCell: React.FC<ToggleCellProps> = ({ checked, onChange, disabled, showSpinner }) => {
  const handleChange = (value: boolean, e: React.MouseEvent) => {
    e.stopPropagation();
    onChange(value, e);
  };

  return (
    <BaseCell>
      <ToggleControl
        size="xs"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        showSpinner={showSpinner}
      />
    </BaseCell>
  );
};

export default ToggleCell;
